import { CHANNEL_FILTER_TYPES } from 'gcs-common/helper/channelTypeHelper';
import { getSearchInput } from 'gcs-common/slices/channelList/channelListSelectors/getSearchInput';
import { getSelectedChannelTypeFilter } from 'gcs-common/slices/channelList/channelListSelectors/getSelectedChannelTypeFilter';
import { setSearchInput } from 'gcs-common/slices/channelList/channelListSlice';
import { useSelector } from 'react-redux';
import ChannelSearchInput from '../ChannelSearchInput/ChannelSearchInput';
import ChannelTypeSelector from '../ChannelTypeSelector/ChannelTypeSelector';
import DirectChannelListWrapper from '../DirectChannelListWrapper/DirectChannelListWrapper';
import SalesSpaceChannelListWrapper from '../SalesSpaceChannelListWrapper/SalesSpaceChannelListWrapper';
import styles from './styles.module.scss';

function AgentChannelListNormal() {
  const channelTypeFilter = useSelector(getSelectedChannelTypeFilter);

  return (
    <>
      <ChannelSearchInput type="searchInput" getSearchInput={getSearchInput} setSearchInput={setSearchInput} />
      <div className={styles.channelListTopBar}>
        <ChannelTypeSelector />
      </div>
      {channelTypeFilter === CHANNEL_FILTER_TYPES.DIRECT_CHATS ? (
        <DirectChannelListWrapper />
      ) : (
        <SalesSpaceChannelListWrapper />
      )}
    </>
  );
}

export default AgentChannelListNormal;

AgentChannelListNormal.propTypes = {};
